const STORAGE_KEY = 'kcn_mobile_chrome_theme';

export type MobileChromeTheme = 'gold' | 'light';

export function getMobileChromeTheme(): MobileChromeTheme {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'gold';
  } catch {
    return 'gold';
  }
}

export function setMobileChromeTheme(theme: MobileChromeTheme): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore
  }
}
